import CreateRental from './CreateRental'
export default CreateRental